import type { PsfSharePageData } from '#src/app/pages/psf/share/pageContext';

/**
 * Shared by the treat hook and the counter so a session is only ever shown the counter if it was also
 * eligible for enrollment. `override` (exo) is deliberately not excluded, so QA keeps the
 * `experiment_variations` signal.
 *
 * Initial view only: Super Recruiter supporters never reach the message view (any `?share=`), where
 * traffic is mostly cold, non-sharing hits that would only dilute the arms.
 */
export function isShareGoalCounterEligible({
	experiment,
	initial,
}: Readonly<{
	experiment: PsfSharePageData['experiments']['psfShareGoalCounterExperiment'];
	initial: PsfSharePageData['initial'];
}>): boolean {
	return (
		initial &&
		experiment.config.enabled &&
		experiment.experimentName !== '__invalid_experiment__' &&
		!experiment.fallback
	);
}
